@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <div
      fxlayout="row"
      fxLayoutAlign="space-between center">
      <div>
        <label class="upper">{{ displayName }}</label>
      </div>
    </div>
    @if (showFieldAsEdit) {
      <div
        style="position: relative">
        <span
          class="material-icons"
          style="position: absolute; top: 8px; left: 8px; color: var(--neutral-color-600)">
          email
        </span>
        <textarea
          rows="3"
          [(ngModel)]="value"
          (ngModelChange)="onValueChanged()"
          class="input is-small is-fullwidth"
          style="padding-left: 34px"
          [ngClass]="{ 'is-error': isError }"
          type="text"
        [placeholder]="displayName"></textarea>
        <div class="ml-1 mt-1 text is-tiny italic">
          {{ 'FIELDS.EMAIL-HELP' | translate }}
        </div>
      </div>
    } @else {
      <div class="is-readonly">{{ valueForDisplay }}</div>
    }
  </div>
}
